import * as React from 'react';

var usePrevious = function usePrevious(value) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
//# sourceMappingURL=use-previous.js.map
